// extracted by mini-css-extract-plugin
export var blue = "_3p-g";
export var brand = "_3p-c";
export var darkGrey = "_3p-f";
export var disabled = "_3p-6";
export var disabledSubtle = "_3p-7";
export var error = "_3p-8";
export var green = "_3p-h";
export var grey = "_3p-e";
export var icon = "_3p-0";
export var inherit = "_3p-b";
export var lightGrey = "_3p-d";
export var orange = "_3p-j";
export var pink = "_3p-l";
export var primary = "_3p-1";
export var purple = "_3p-m";
export var quaternary = "_3p-4";
export var quinary = "_3p-5";
export var red = "_3p-k";
export var secondary = "_3p-2";
export var success = "_3p-a";
export var tertiary = "_3p-3";
export var warning = "_3p-9";
export var white = "_3p-n";
export var yellow = "_3p-i";